import axios, { AxiosError, AxiosRequestConfig } from 'axios';

import { useAuthStore } from '@/store/auth';
import { IApiResponse } from '../interfaces';

export const erpApiFile = () => {
  const sendRequest = async <T>(
    method: string,
    url: string,
    auth: boolean,
    typeJson: boolean = true,
    data = null,
    contentType = 'multipart/form-data'
  ): Promise<IApiResponse<T>> => {
    try {

      const storedTokenDrive = useAuthStore.getState().token_drive;

      const config: AxiosRequestConfig = {
        method: method,
        url: url,
        data: data,
        timeout: 5000,
        responseType: typeJson ? 'json' : 'blob',
      };

      if (auth) {
        config.headers = {
          Authorization: `Token ${storedTokenDrive}`,
          'Content-Type': contentType,
        };
      }

      const response = await axios<IApiResponse<T>>(config);

      if (response.data.code != 200) {
        const dataError = {
          code: response.data.code,
          message: response.data.message,
          status: 'warning',
          data: response.data as any,
        };
        return dataError;
      }

      return response.data;
    } catch (err: unknown) {
      let dataError: IApiResponse<T> = {
        code: 0,
        message: 'Error desconocido',
        status: 'error',
        data: null as any,
      };

      if (axios.isAxiosError(err)) {
        const axiosError = err as AxiosError;
        const respError: IApiResponse<T> = axiosError.response?.data as any;
        dataError = {
          code: respError.code,
          message: respError.message,
          status: 'error',
          data: null as any,
        };
      }

      return dataError;
    }
  };

  const get = async function <T>(
    url: string,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<IApiResponse<T>> {
    return sendRequest<T>('GET', url, auth, typeJson);
  };

  const post = async function <T>(
    url: string,
    data: any,
    auth: boolean,
    typeJson: boolean = true,
    contentType = 'multipart/form-data'
  ): Promise<IApiResponse<T>> {
    return sendRequest<T>('POST', url, auth, typeJson, data, contentType);
  };

  const put = async function <T>(
    url: string,
    data: any,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<IApiResponse<T>> {
    return sendRequest<T>('PUT', url, auth, typeJson, data);
  };

  const remove = async function <T>(
    url: string,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<IApiResponse<T>> {
    return sendRequest<T>('DELETE', url, auth, typeJson);
  };

  return {
    get,
    post,
    put,
    remove,
  };
};
